import styled from "styled-components";
interface IProps {
  full: boolean;
}
const WrapperContainer = styled.div<IProps>`
  margin: 132px auto 0 auto;
  max-width: ${(props) => (props.full ? "unset" : "1224px")};

  @media (max-width: 1000px) {
    max-width: unset;
    width: 100%;
    margin: 70px 0 0 0;
  }
`;

const ContentWrapper = ({ children, fullWidth }: any) => {
  return (
    <>
      <WrapperContainer full={fullWidth}>{children}</WrapperContainer>
    </>
  );
};

export default ContentWrapper;
